var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.2 0H2.8C1.26 0 0.014 1.29375 0.014 2.875L0 20.125C0 21.7062 1.26 23 2.8 23H25.2C26.74 23 28 21.7062 28 20.125V2.875C28 1.29375 26.74 0 25.2 0ZM25.2 5.75L14 12.9375L2.8 5.75V2.875L14 10.0625L25.2 2.875V5.75Z","fill":"#38B2B1"}));
}

Mail.defaultProps = {"width":"28","height":"23","viewBox":"0 0 28 23","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
